import React, { Component } from 'react';
import { findDOMNode } from "react-dom";
import './terms.css';

class Terms extends Component {
    constructor(props) {
        super(props);
        this.section = [React.createRef(), React.createRef(), React.createRef() ]
        this.state = {
            terms : []                     
        };
      }

    componentDidMount() {
        this.getTerms();
      }

    termsScrollTo(e) {
        const scrollThis = (parseInt(e.currentTarget.dataset.id, 10));
        var myElement = findDOMNode(this.section[scrollThis].current)
        myElement.scrollIntoView({behavior: "instant", block: "center", inline: "nearest"});
        console.log(myElement);
      }
    
      // Retrieves the list of items from the Express app
      getTerms = () => {
        fetch('/api/terms')
        .then(res => res.json())
        .then(terms => this.setState({ terms }));

      }

    render() {
        const { terms } = this.state;
        
        return (
            <React.Fragment>
                {terms.length ? (
                <React.Fragment>
                    <div className="menuCase mapContent fullStage hoverRed relative" style={{"opacity": this.props.mapVis[1]}} >
                        {/* Render the list of items */}
            
                        {terms.map((terms, i) => {
                        return(
                            <React.Fragment key={i}>

                            {window.innerWidth >= 900 ? (
                                <div className="termsNavHold">
                                    <h1 className="resourceLinks upperT blkT boldT marginBotTiny">Sections</h1>
                                    <p className="subNav blkT" onClick={this.termsScrollTo.bind(this)} data-id="0">10 General Rules</p>
                                    <p className="subNav blkT" onClick={this.termsScrollTo.bind(this)} data-id="1">Mumbo Jumbo</p>
                                    <p className="subNav blkT" onClick={this.termsScrollTo.bind(this)} data-id="2">Sects</p>

                                    <h1 className="resourceLinks upperT blkT boldT marginTopSmall marginBotTiny">Sources</h1>
                                    <div className="blkT" dangerouslySetInnerHTML={{ __html : terms.termsSources }}></div>     
                                </div>
                            ):('')}
                                


                                <div className="termsStage tfStage oneColumnPush marginBotLarge" dangerouslySetInnerHTML={{ __html : terms.termsIntro }}></div>
                                <h2 className=" termsStage tfStage oneColumnPush marginBotSmall" ref={this.section[0]} dangerouslySetInnerHTML={{ __html : terms.termsRulesTitle }}></h2>
                                <div className="termsList tfStage oneColumnPush marginBotLarge" dangerouslySetInnerHTML={{ __html : terms.termsRulesList }}></div>
                                <h2 className="termsStage tfStage oneColumnPush marginBotSmall" ref={this.section[1]} dangerouslySetInnerHTML={{ __html : terms.termsMumboTitle }}></h2>
                                <div className="termsStage tfStage oneColumnPush marginBotLarge termsMumbo mumboCopy" dangerouslySetInnerHTML={{ __html : terms.termsMumboCopy }}></div>
                                <h2 className="termsStage tfStage oneColumnPush marginBotSmall" ref={this.section[2]} dangerouslySetInnerHTML={{ __html : terms.termsSectTitle }}></h2>
                                <div className="termsStage tfStage oneColumnPush marginBotLarge termsMumbo mumboCopy" dangerouslySetInnerHTML={{ __html : terms.termsSectCopy }}></div>
                                <div className="termsStage tfStage oneColumnPush" dangerouslySetInnerHTML={{ __html : terms.termsResources }}></div>
                                
                                
                            </React.Fragment>
                        );
                        })}
                    </div>
                   </React.Fragment>
                    ) : (
                        <div className="fullWidth fullHeight redT blinkFast loader">
                        <div className="centeredContent">•</div>
                    </div>
                    
                    )
                }
            </React.Fragment>
        )
    }
  }
  
  export default Terms




// WEBPACK FOOTER //
// ./src/components/terms/terms.js